import SelectInput, {SelectInputProps} from '@/components/refinedev/SelectInput';
import {InputProps} from '@/hooks/useInput';
import {useList} from '@refinedev/core';

export const DepartmentSelectInput = (props: SelectInputProps) => {
  const departmentList = useList({
    resource: 'departments',
    sorters: [{field: 'name', order: 'asc'}],
    pagination: {current: 0, pageSize: 9999},
  });

  const choices = departmentList.data?.data ? departmentList.data.data : [];

  return <SelectInput choices={choices} optionText="name" emptyOptionText="<Tất cả>" {...props} />;
};
